<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Badania lekarskie</span>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja badania</template>
          <template v-else>Dodawania badania</template>
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/badania')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button
          theme="success"
          @click.prevent="validateForm">
          Zapisz zmiany
        </d-button>
      </d-col>
    </d-row>
    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab title="Dane ogólne" active>
            <h4 class="mb-3 pb-3 border-bottom">
              Dane ogólne
            </h4>
            <validation-observer ref="medical-examinations-form" tag="form">
              <d-row>
                <d-col>
                  <div class="form-group">
                    <label for="name">
                      Nazwa:
                    </label>
                    <validation-provider
                            rules="required"
                            name="name"
                            v-slot="{ errors }">
                      <d-input
                              :state="errors.length ? 'invalid' : null"
                              v-model="data.name" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col>
                  <div class="form-group">
                    <label for="description">
                      Opis badania:
                    </label>
                    <validation-provider
                            rules="required"
                            name="description"
                            v-slot="{ errors }">
                      <d-input
                              :state="errors.length ? 'invalid' : null"
                              v-model="data.description" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>
              <d-row>
                <d-col>
                  <div class="form-group">
                    <validation-provider
                            v-slot="{ errors }">
                      <d-checkbox
                              :state="errors.length ? 'invalid' : null"
                              :checked="String"
                              :value="'1'"
                              :unchecked-value="'0'"
                              v-model="data.is_report"
                      >
                        Uwzględnij przy generowaniu raportu SIO
                      </d-checkbox>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>
            </validation-observer>
            <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>
            <d-alert
              v-if="loadError"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'medical-examinations-form',
  computed: {
    allDataLoaded () {
      return this.loaded && this.loadedMedical;
    },
    isEdit () {
      return !!this.$route.params.id;
    }
  },
  data() {
    return {
      data: {
        name: '',
        description: '',
        is_report: '0'
      },
      loaded: false,
      loadError: false,
      medicalExaminations: [],
      loadedMedical: false
    };
  },
  mounted () {
    if (this.isEdit) {
      this.loadItemData();
    } else {
      this.loaded = true;
    }

    this.loadAdditionalData();
  },
  methods: {
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/medical-examinations/item/',
        instanceFields: ['id', 'name', 'description', 'is_report'],
        loadedKey: 'loaded'
      });
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/medical-examinations/items',
        params: {
          pagination: false
        },
        outputKey: 'medicalExaminations',
        loadedKey: 'loadedMedical',
        errorKey: 'loadError',
        successAction: () => {
          if (this.data.id) {
            this.medicalExaminations = this.medicalExaminations.filter(medicalExaminations => medicalExaminations.id !== this.data.id);
          }
        }
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['medical-examinations-form'], this.submitForm);
    },
    submitForm () {
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = this.isEdit ? '/medical-examinations/update/' + this.id : '/medical-examinations/store';

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano badanie',
        successText: 'Wybrane badanie zostało zapisane',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacje badania nie powiodły się. Spróbuj ponownie.',
        successAction: () => {
          this.$router.push('/badania')
        }
      });
    },
    prepareFormDataToSend () {
      return {
        name: this.data.name,
        description: this.data.description,
        is_report: this.data.is_report
      };
    }
  }
};
</script>
